import { render, staticRenderFns } from "./LifecycleTags.vue?vue&type=template&id=708a3a5b&scoped=true&"
import script from "./LifecycleTags.vue?vue&type=script&lang=js&"
export * from "./LifecycleTags.vue?vue&type=script&lang=js&"
import style0 from "./LifecycleTags.vue?vue&type=style&index=0&id=708a3a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a3a5b",
  null
  
)

export default component.exports